import React, { Component } from 'react';
import Link from 'redux-first-router-link';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import cartAnalytics from './cartAnalytics';
import Input from '../Elements/Input/Input';
import Button from '../Elements/Button/Button';
import FakeSelect from '../Elements/FakeSelect/FakeSelect';
import Price from '../Product/Price';
import { changeQuantity, changeSize, updateKlarna, updatePaymentMethod, addToBag, retrieveProductCache } from '../../actions/checkout';
import { translate, translateObjectData, prefix } from '../../utils/locale';
import s from './CartItems.scss';

class CartItems extends Component {
	constructor(props) {
		super(props);

		this.state = {
			initials: '',
			personalized: {}, // { 24-234: { embossingItem: 224-45, initials: '' } }
		};
	}

	updateQuantityHandler = (e) => {
		e.preventDefault();
		const { checkout, currentPage, setup } = this.props;
		const $link = e.currentTarget;
		const itemId = $link.closest('.checkoutItem').dataset.item;
		const itemObj = checkout.selection.items.reduce((acc, item) => ({ ...acc, ...(item.item === itemId ? item : {}) }), {});
		const cachedItem = Object.keys(checkout.selectionCache).filter((scItem) => scItem === itemId.split('-')[0]).map((scItem) => checkout.selectionCache[scItem])[0];
		const action = $link.getAttribute('href').slice(1);
		let quantity = itemObj.quantity;
		let analyticsQuantity = 1;

		switch (action) {
			case 'increase':
				quantity += 1;
				break;
			case 'decrease':
				quantity -= 1;
				break;
			case 'remove':
				quantity = 0;
				analyticsQuantity = itemObj.quantity;
				break;
			default:
				break;
		}

		this.props.changeQuantity(itemObj, quantity)
			.then((response) => {
				if (currentPage === 'selection') {
					this.props.updateKlarna();
					this.props.updatePaymentMethod();
				}

				cartAnalytics(cachedItem, itemObj, setup, false, cachedItem.category, response.data.selection, checkout.listItemCache, ['remove', 'decrease'].indexOf(action) !== -1, analyticsQuantity);

				return response;
			}).catch((err) => console.log('DEBUG: quantity did not change', err));
	}

	openPersonalizeItem = (e) => {
		e.preventDefault();
		const item = e.currentTarget.parentElement.dataset.item;

		this.setState((prevState) => {
			if (prevState.personalized[item]) {
				return {
					personalized: {
						...prevState.personalized,
						[item]: null,
					},
				};
			}

			return {
				personalized: {
					...prevState.personalized,
					[item]: {
						embossingItem: '',
						initials: '',
					},
				},
			};
		});
	}

	personalizeItem = (e) => {
		e.preventDefault();
		const { personalized } = this.state;
		const $form = e.currentTarget;
		const item = $form.dataset.item;

		if (personalized[item] && personalized[item].embossingItem && personalized[item].initials !== '') {
			const { checkout, currentPage, setup, productCache } = this.props;
			const { products = {} } = (productCache[setup.market] && productCache[setup.market][setup.pricelist]) || {};

			const productId = item.slice(0, item.indexOf('-'));
			let embossedOnProduct = checkout.selectionCache[productId];
			if (!embossedOnProduct && products) embossedOnProduct = products[productId];
			let sizeName = '';
			embossedOnProduct.sizes.forEach((size) => {
				if (size.item === item.item) sizeName = size.name;
			});

			const embossingId = personalized[item].embossingItem.slice(0, personalized[item].embossingItem.indexOf('-'));
			const cachedProduct = products[embossingId];

			const note = {
				item,
				message: `Product: ${embossedOnProduct.name} ${embossedOnProduct.variantName} — Size: ${sizeName} — Initials: ${personalized[item].initials} — Embossing Product: ${cachedProduct.name}`,
				details: { ...personalized[item] },
			};
			this.props.addToBag(personalized[item].embossingItem, 1, currentPage, cachedProduct, note)
				.then((response) => {
					if (currentPage === 'selection') {
						this.props.updateKlarna();
						this.props.updatePaymentMethod();
					}

					cartAnalytics(cachedProduct, personalized[item].embossingItem, setup, false, cachedProduct.canonicalUri, response.data.selection, checkout.listItemCache, false, 1);

					return response;
				}).catch((err) => console.log('DEBUG: not able to add personalization', err));
		}
	}

	setInitials = (id, value) => {
		const item = id.replace('intials_', '');
		let filteredValue = value.toUpperCase().replace(/[^A-ZÅÄÖ.,\-&]/, '');
		if (filteredValue.replace(/[^A-ZÅÄÖ&]/g, '').length > 3) filteredValue = filteredValue.slice(0, -1);

		this.setState((prevState) => ({
			initials: filteredValue,
			personalized: {
				...prevState.personalized,
				[item]: {
					...prevState.personalized[item],
					initials: filteredValue,
				},
			},
		}));
	}

	selectEmbossingType = (embossingItem, e) => {
		const item = e.closest('form').dataset.item;
		this.setState((prevState) => ({
			personalized: {
				...prevState.personalized,
				[item]: {
					...prevState.personalized[item],
					embossingItem,
				},
			},
		}));
	}

	renderEmbossedItem = (additionalInformation, embossingItem) => (
		<div>
			<div className={s.cartItem_personalize_product}>{ embossingItem[0].name } ({embossingItem[0].priceEach})</div>
			<div className={s.cartItem_personalize_initials}>{ additionalInformation[0].details.initials }</div>
		</div>
	)

	renderCustomizeEmbossing = (item, embossingChoices, setup, personalized, initials) => (
		<>
			<div className={s.cartItem_closePersonalize} data-item={item.item}>
				<a className={s.cartItem_closePersonalize_link} href="#remove-personalization" onClick={this.openPersonalizeItem} aria-labelledby="Remove Personalization">
					<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
						<g fill="none" stroke="#000" strokeLinecap="square" strokeWidth="1.5" transform="rotate(-45 17.39 3.11)">
							<line x1="7.793" x2="7.793" y2="15" />
							<line x1="15" y1="7.707" y2="7.707" />
						</g>
					</svg>
				</a>
			</div>
			<div className={s.cartItem_personalize}>
				<form className={s.cartItem_personalize_form} onSubmit={this.personalizeItem} data-item={item.item}>
					{ !personalized[item.item].embossingItem && <FakeSelect items={embossingChoices} title={translate(setup, 'selectType')} selectionHandler={this.selectEmbossingType} adaption="emboss" /> }
					{ personalized[item.item].embossingItem && <Input id={`intials_${item.item}`} type="text" label={translate(setup, 'personalizeInitials')} value={personalized[item.item].initials || initials} inputChange={this.setInitials} width={window.innerWidth < 600 ? '120px' : '185px'} /> }
					{ personalized[item.item].embossingItem && <Button type="submit" text={translate(setup, 'personalizeAdd')} /> }
					<div className={s.cartItem_personalize_form_moreInfo}>
						<Link to={translate(setup, 'personalizeMoreInfoLink')}>{translate(setup, 'personalizeMoreInfo')}</Link>
					</div>
				</form>
			</div>
		</>
	)

	renderAddEmbossing = (item, setup) => (
		<div className={s.cartItem_initPersonalize} data-item={item.item}>
			<Button type="a" href="#add-personalization" text={translate(setup, 'personalizeAdd')} clickEventHandler={this.openPersonalizeItem} />
		</div>
	)

	render() {
		const { checkout, currentPage, setup, productCache } = this.props;
		if (!productCache?.[setup.market]?.[setup.pricelist]) {
			this.props.retrieveProductCache();
			return null;
		}
		const { personalized, initials } = this.state;
		const { products = {}, filterArrays = { categories: {} } } = productCache?.[setup.market]?.[setup.pricelist] || {};
		const embossingItems = (filterArrays.categories.embossing && filterArrays.categories.embossing.map((item) => products[item]).filter((item) => !!item)) || [];
		const embossingChoices = embossingItems.map((item) => ({
			key: item.sizes[0].item,
			value: `${item.name} (${item.price.price})`,
		}));

		const lineItems = checkout.selection.items ? checkout.selection.items.filter((item) => {
			// Filter out embossing items and append them as text instead.
			const productId = item.item.slice(0, item.item.indexOf('-'));
			if (!filterArrays.categories.embossing || (filterArrays.categories.embossing && filterArrays.categories.embossing.indexOf(productId) === -1)) return true;
			return false;
		}).map((item) => {
			const productId = item.item.slice(0, item.item.indexOf('-'));
			const itemCache = checkout.selectionCache[productId] || products[productId];
			const itemDetails = translateObjectData(setup, itemCache);
			if (item.quantity === 0 || !itemDetails) return null;

			const additionalInformation = checkout.payment.additionalInformation.filter((customItem) => item.item === customItem.item);
			const embossingItem = additionalInformation.length > 0 ? checkout.selection.items.filter((selectionItem) => additionalInformation[0].details.embossingItem === selectionItem.item) : [];

			const price = {};
			Object.keys(item).forEach((priceItem) => {
				if (priceItem.indexOf('price') === 0) price[priceItem.replace('priceEach', 'price')] = item[priceItem];
			});

			return (
				<div key={item.item} className={[s.cartItem, 'checkoutItem'].join(' ')} data-item={item.item}>
					<Link className={s.cartItem_image} to={prefix(setup, (itemDetails.category ? itemDetails.category : itemDetails.canonicalUri))}>
						{ itemDetails?.image && itemDetails.image.length > 0 ? <img src={itemDetails?.image[0].replace(/\.(\w+)$/, '-thumb.$1')} alt={itemDetails.name} /> : null }
					</Link>
					<div className={s.cartItem_info}>
						<div>
							<span className={s.cartItem_info_brand}>{ itemDetails.brand }</span>
							<span className={s.cartItem_info_name}>{ itemDetails.name }<br />{ itemDetails.variantName }</span>
							<span className={s.cartItem_info_price}><Price price={price} /></span>
							{ item.size.toLowerCase() !== 'one size' && <span className={s.cartItem_info_size}>{ translate(setup, 'size') }: { item.size }</span> }
							{ itemDetails.embossable && additionalInformation.length > 0 && embossingItem.length > 0 && this.renderEmbossedItem(additionalInformation, embossingItem) }
						</div>
						{
							currentPage !== 'receipt' ? (
								<div className={s.cartItem_info_changeQuantity}>
									<a className={s.cartItem_info_changeQuantity_remove} href="#remove" onClick={this.updateQuantityHandler}>
										<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
											<g fill="none" stroke="#000" strokeLinecap="square" strokeWidth="1.5" transform="rotate(-45 17.39 3.11)">
												<line x1="7.793" x2="7.793" y2="15" />
												<line x1="15" y1="7.707" y2="7.707" />
											</g>
										</svg>
									</a>
									<a className={[s.cartItem_info_changeQuantity_button, s.cartItem_info_changeQuantity_button__decrease].join(' ')} href="#decrease" onClick={this.updateQuantityHandler}>
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="2" viewBox="0 0 16 2">
											<line x1="14" y1="1" y2="1" fill="none" stroke="#000" strokeLinecap="square" strokeWidth="1.5" transform="translate(1)" />
										</svg>
									</a>
									<span className={s.cartItem_info_changeQuantity_quantity}>{ item.quantity }</span>
									<a className={s.cartItem_info_changeQuantity_button} href="#increase" onClick={this.updateQuantityHandler}>
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
											<g fill="none" fillRule="evenodd" stroke="#000" strokeLinecap="square" strokeWidth="1.5" transform="translate(1 1)">
												<line x1="7.5" x2="7.5" y2="14" />
												<line x1="14" y1="7" y2="7" />
											</g>
										</svg>
									</a>
								</div>
							) : <span className={s.cartItem_info_changeQuantity_quantity}>{ item.quantity }</span>
						}
					</div>
					{ currentPage === 'selection' && itemDetails.embossable && additionalInformation.length === 0 && personalized[item.item] && this.renderCustomizeEmbossing(item, embossingChoices, setup, personalized, initials) }
					{ currentPage === 'selection' && itemDetails.embossable && additionalInformation.length === 0 && !personalized[item.item] && this.renderAddEmbossing(item, setup) }
				</div>
			);
		}) : [];

		return (
			<div className={s.cartItems}>
				{ checkout.selection.items ? lineItems : <span>{ translate(setup, 'noItems') }</span> }
			</div>
		);
	}
}

const mapState = ({ environment, checkout, productCache }, { currentPage }) => ({ checkout, setup: environment.setup, productCache, currentPage });

export default hot(module)(connect(mapState, { changeQuantity, changeSize, updateKlarna, updatePaymentMethod, addToBag, retrieveProductCache })(CartItems));
